module.exports = __webpack_public_path__ + "static/media/astronautas.8157ba13.svg";